import { property, subclass } from "@arcgis/core//core/accessorSupport/decorators";
import Accessor from "@arcgis/core/core/Accessor";
import { filterType, IChipState } from '../FilterChips';

@subclass("FilterChipsViewModel")
export default class FilterChipsViewModel extends Accessor {

  @property()
  chips: __esri.Collection<IChipState>;

  constructor(params?: any) {
    super(params);
  }

  addChip(text: string, filterType: filterType): {success: boolean}{
    const existingIndex = this.chips.findIndex((chip)=>{
      return chip.text === text && chip.filterType === filterType;
    });
    if(existingIndex === -1){
      this.chips.add({
        guid: `${text}`,
        text,
        filterType
      });
      return {success: true};
    } else{
      return {success: false};
    }
  }

}